import { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import withRequestId from 'core/hocs/withRequestId';

import EmptyWrapper from 'core/components/EmptyWrapper';
import DesktopAdSiteWrapper from 'core/components/Ad/DesktopAdSiteWrapper';
import { PageNumbersProvider } from 'core/components/Ad/resolve/pageNumbers';
import Erratum from 'core/components/Erratum';
import ExchangeProvider from 'core/components/Exchange/ExchangeProvider';
import { GlobalTopicContext } from 'core/components/GlobalTopicProvider';

import styles from './index.styl';


function SiteWrapper(props, context) {
  const {
    children,
    theme,
    isDesktop,
    requestId,
  } = props;

  const {
    erratumUrl,
    features: {
      enableFenwick,
    },
  } = context;

  const topic = useContext(GlobalTopicContext);

  const Wrapper = isDesktop
    ? DesktopAdSiteWrapper
    : EmptyWrapper;

  const ExchangeOrEmpty = enableFenwick
    ? ExchangeProvider
    : EmptyWrapper;

  const isPremiumTopic = topic?.attributes?.is_premium;

  return (
    <Wrapper minWidth={parseInt(theme.layout.minWidth, 10)}>
      <style jsx>{`
        .${styles.overlay}
          box-shadow ${theme.layout.boxShadow}
          max-width ${theme.layout.maxWidth}
          &._premiumTopic
            box-shadow none
        :global(body)
          min-width ${theme.layout.minWidth}
      `}</style>
      {/*
        Класс .site-overlay не удалять!
        Он используется для рекламы.
        Также на .site-overlay класс добавлены стили с помощью которых можно убрать тень у приложения.
        Используется storybook
       */}
      <div className={cx(`site-overlay ${styles.overlay}`, isPremiumTopic && '_premiumTopic')}>
        <PageNumbersProvider requestId={requestId}>
          <ExchangeOrEmpty>
            {children}
          </ExchangeOrEmpty>
        </PageNumbersProvider>
      </div>
      {erratumUrl && <Erratum />}
    </Wrapper>
  );
}

SiteWrapper.propTypes = {
  requestId: PropTypes.string,
  theme: PropTypes.object,
  isDesktop: PropTypes.bool,
};

SiteWrapper.contextTypes = {
  erratumUrl: PropTypes.string,
  features: PropTypes.shape({
    enableFenwick: PropTypes.bool,
  }),
};

export default withRequestId(SiteWrapper);
